import { Component, OnInit, Inject, HostBinding } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export const TRANSFER_PIXELS = 'TRANSFER_PIXELS';

@Component({
    selector: 'app-dlg-store-pixel',
    templateUrl: './dlg-store-pixel.component.pug',
    styleUrls: ['./dlg-store-pixel.component.less'],
})
export class DlgStorePixelComponent implements OnInit {
    @HostBinding('class.effect--grayscale') disabled: boolean = false;

    constructor(
        public _dialogRef: MatDialogRef<DlgStorePixelComponent>,

        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {
        // This is hack to close by backdrop.
        const overlayWrapper = this._dialogRef['_overlayRef'].overlayElement.parentElement;

        overlayWrapper.addEventListener('click', ({ target }) => {
            if (overlayWrapper !== target) {
                return;
            }

            this.onClose();
        });
    }

    onClose() {
        this.data.close();
    }

    onTransfer(payload: any) {
        this.data.transfer(payload);
    }
}
